import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import StorySection from './components/StorySection';
import LegacySection from './components/LegacySection';
import MissionVisionSection from './components/MissionVisionSection';
import ValuesSection from './components/ValuesSection';
import GallerySection from './components/GallerySection';

export default function About() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <AboutHero />
        <StorySection />
        <LegacySection />
        <MissionVisionSection />
        <ValuesSection />
        <GallerySection />
      </main>
      <Footer />
    </div>
  );
}